import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const Label = styled.label`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.2px;
`
